import { FormikComboBox } from 'components/ComboBox/FormikComboBox'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { useCurrentProving } from 'hooks/useCurrentProving'
import { uniq } from 'lodash'
import * as React from 'react'

export const ProvingDetailsGroupForm: React.FC<{
  notification?: boolean
  wizard?: boolean
}> = ({ notification, wizard }) => {
  const [proving] = useCurrentProving()
  const groups: string[] = []
  ;(proving.participants || []).forEach((p) => {
    if (p.group) {
      groups.push(p.group)
    }
  })
  ;(proving.vehicles || []).forEach((v) => {
    if (v.group) {
      groups.push(v.group)
    }
  })
  ;(proving.materials || []).forEach((m) => {
    if (m.group) {
      groups.push(m.group)
    }
  })
  const options = uniq(groups).map((group) => ({
    key: group,
    text: group,
  }))

  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name={'group'}
          render={(fieldProps) => (
            <FormikComboBox
              label="Gruppe zuweisen"
              options={options}
              allowFreeform={true}
              {...fieldProps}
            />
          )}
        />
      </FieldStack>
    </FormStack>
  )
}
